import {Injectable, Signal, computed, signal} from '@angular/core';
import {UserDetails} from '../../shared/models/policy.model';

export function createInitialState(): UserDetails {
  return {
    console_access: false,
    broker_id: 0,
    brokerage_id: 0,
    first_name: '',
    last_name: '',
    person_id: 0,
    person_tel: '',
    person_email: '',
    username: '',
    role: '',
    access_token: '',
    refresh_token: '',
    partner_code: ''
  };
}

const STORAGE_KEY = 'userState';

function loadPersistedState(): UserDetails {
  try {
    const own = localStorage.getItem(STORAGE_KEY);
    if (own) {
      return {...createInitialState(), ...JSON.parse(own)};
    }
    // One-time migration: seed from Akita's persistState blob so existing
    // sessions survive the switch to the signal-backed store.
    const akita = localStorage.getItem('AkitaStores');
    if (akita) {
      const user = JSON.parse(akita)?.user;
      if (user) {
        return {...createInitialState(), ...user};
      }
    }
  } catch {
  }
  return createInitialState();
}

@Injectable({
  providedIn: 'root'
})
export class UserStore {
  private readonly state = signal<UserDetails>(loadPersistedState());

  /** Reactive read access — preferred for new code. */
  readonly user: Signal<UserDetails> = this.state.asReadonly();
  readonly isLoggedIn = computed(() => !!this.state().access_token);

  getValue(): UserDetails {
    return this.state();
  }

  update(stateOrCallback: Partial<UserDetails> | ((state: UserDetails) => Partial<UserDetails>)): void {
    const current = this.state();
    const partial = typeof stateOrCallback === 'function' ? stateOrCallback(current) : stateOrCallback;
    this.commit({...current, ...partial});
  }

  reset(): void {
    this.commit(createInitialState());
  }

  private commit(next: UserDetails): void {
    this.state.set(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
    }
  }
}
